// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-toast {
  z-index: 1350;
}

/* Change close button hover color from red to dark gray */
.custom-toast .swal2-close:hover {
  color: #4b5563 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/toaster/toaster.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;AAC3B","sourcesContent":[".custom-toast {\n  z-index: 1350;\n}\n\n/* Change close button hover color from red to dark gray */\n.custom-toast .swal2-close:hover {\n  color: #4b5563 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
